module.exports = __webpack_public_path__ + "static/img/120003.34a12339.png";